import React, { useState, useEffect } from 'react';

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography
} from '@material-ui/core';
import Axios from 'axios';
import { Html5QrcodeScanner } from 'html5-qrcode';

import PaperComponent from 'components/PaperComponent';
import CloseIconNavy from 'images/icons/signals/closesAndCancels/closeTransparent.svg';
import Environment from 'utils/environments';

const environments = Environment(process.env.REACT_APP_ENV);

function DialogNfce({
  userInfo,
  openModal,
  handleCloseModal,
  setAlertNfce,
  setInputKey,
  setDataReceives,
  setNfceType,
  findKeyNote,
  setCollapseSettings
}) {
  const [data, setData] = useState();
  const [typeFormatScanner, setTypeFormatScanner] = useState({
    width: 250,
    height: 250,
    type: 'qrCode'
  });
  const restaurantId = userInfo?.companiesActive?.id;

  const cancelQrCode = () => {
    handleCloseModal();
    setData('');
  };

  const getQrCode = (qrCodeValue) => {
    const payload = {
      qrCode: qrCodeValue,
      restaurantId: restaurantId,
      user: userInfo.user
    }

    Axios.post(`${environments.integration}/nfce`, payload)
      .then((res) => {
        if (res.data.message) {
          setNfceType({
            valid: true,
            code: data
          })
          setAlertNfce({
            message: 'Nota em processamento...',
            status: 'success'
          });

          // const qrCodeNumbers = data?.split("=")?.length ? data?.split("=")[1].substring(0, 44) : data

          // setTimeout(() => {
          //   findKeyNote(qrCodeNumbers, true, true)
          // }, 1500);
        } else {
          setDataReceives([res.data])
          setCollapseSettings(
            [res?.data].map((order) => ({
              id: order?._id,
              open: false
            }))
          );
        }
      })
      .catch((error) => {
        let message = `Erro ao enviar nota.`

        if (error.response) {
          if (error.response.message) {
            message += `\n Erro: ${error.response.message}`
          }
        } else if (error.message) {
          message += `\n Erro: ${error.message}`
        }

        setAlertNfce({
          message: message,
          status: 'error'
        });
      })
  };

  useEffect(() => {
    if (openModal) {
      // Salva o método console.warn original
      const originalWarn = console.warn;

      // Substitui console.warn para suprimir mensagens específicas
      console.warn = (message, ...optionalParams) => {
        if (typeof message === "string" && message.includes("No MultiFormat Readers were able to detect the code")) {
          return; // Ignora mensagens com esse texto
        }
        originalWarn(message, ...optionalParams);
      };

      let scanner;

      const initializeScanner = () => {
        const success = (result) => {
          scanner.clear();
          setData(result);
        }

        const error = (err) => {
          // Você pode tratar outros erros aqui, se necessário
        }

        const element = document.getElementById("reader");

        if (element) {
          scanner = new Html5QrcodeScanner("reader", {
            qrbox: { width: typeFormatScanner.width, height: typeFormatScanner.height },
            fps: 600,
            facingMode: "environment",
            verbose: true
          });

          scanner.render(success, error);
        }
      };

      const timeoutId = setTimeout(initializeScanner, 1000);

      // Limpa o scanner e restaura o console.warn original ao desmontar o componente ou alterar o scanner
      return () => {
        clearTimeout(timeoutId);
        console.warn = originalWarn;
        if (scanner) scanner.clear();
      };
    }
  }, [openModal, typeFormatScanner]);

  useEffect(() => {
    if (typeFormatScanner?.type === 'barCode') {
      if (data?.length === 44) {
        setInputKey(data)
        findKeyNote(data)
        cancelQrCode();
        return;
      }

      if (data?.length && data?.length !== 44) {
        setAlertNfce({
          message: 'Não foi possível ler a nota corretamente.',
          status: 'error'
        });
      }

      return;
    }

    if (data) {
      getQrCode(data);
      cancelQrCode();
    }
  }, [data]);

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={openModal}
      onClose={() => {
        cancelQrCode()
      }}
      PaperComponent={PaperComponent}
      className="qrCodeReaderNotesDialog"
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle
        className="modalHeader navyBlue bold textAlignCenter cursorMove"
      >
        <Typography
          id="draggable-dialog-title"
          className="textAlignLeft"
          style={{ width: "90%" }}
        >
          Escanear Nota
        </Typography>

        <IconButton
          edge="start"
          color="inherit"
          onClick={() => {
            cancelQrCode()
          }}
        >
          <img style={{ width: '16px' }} src={CloseIconNavy} alt="CloseIconNavy" />
        </IconButton>
      </DialogTitle>

      <DialogContent className="modalContent p12">
        <Grid container spacing={6} className="w100 alignCenter justifyCenter m0">
          {!data ?
            <div
              style={{ border: '1px solid black', margin: '10px 0' }}
              className="w100 qr-scanner"
            >
              <div id="reader" />
            </div>
            : null}
        </Grid>

        <Grid container spacing={6} className="w100 m0">
          <div style={{ gap: '10px' }} className="w100 dFlex alignCenter justifyCenter pb8">
            <Button
              variant="contained"
              style={{
                background: typeFormatScanner.type === 'qrCode' ? '#5062F0' : 'transparent',
                borderRadius: '8px',
                height: '40px',
                color: typeFormatScanner.type === 'qrCode' ? '#FFF' : '#000'
              }}
              fullWidth
              disabled={typeFormatScanner.type === 'qrCode'}
              onClick={() => {
                setTypeFormatScanner({
                  width: 250,
                  height: 250,
                  type: 'qrCode'
                })
              }}
            >
              QrCode
            </Button>

            <Button
              variant="contained"
              style={{
                background: typeFormatScanner.type === 'barCode' ? '#5062F0' : 'transparent',
                borderRadius: '8px',
                height: '40px',
                color: typeFormatScanner.type === 'barCode' ? '#FFF' : '#000'
              }}
              fullWidth
              disabled={typeFormatScanner.type === 'barCode'}
              onClick={() => {
                setTypeFormatScanner({
                  width: 250,
                  height: 90,
                  type: 'barCode',
                })
              }}
            >
              Código de Barras
            </Button>
          </div>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default DialogNfce;
